// client/src/services/api.js
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://tripsie.in/api';

export const SERVER_URL = API_BASE_URL.replace(/\/api\/?$/, '');

export const getImageUrl = (path) => {
  if (!path) return '';
  if (path.startsWith('http') || path.startsWith('blob:') || path.startsWith('data:')) return path;
  return `${SERVER_URL}${path}`;
};

const api = axios.create({
  baseURL: API_BASE_URL,
});

// Public routes that must never send an Authorization header.
// ★ FIX: Use exact-match instead of .includes() so that
//   /auth/google/complete-setup is NOT mistakenly treated as public
//   just because it contains the public path /auth/google.
const PUBLIC_PATHS = [
  '/auth/login',
  '/auth/register',
  '/auth/google',           // exact Google OAuth entry point
  '/auth/send-otp',
  '/auth/check-username',
  '/auth/forgot-password',
  '/auth/verify-forgot-password-otp',
  '/auth/reset-password',
];

api.interceptors.request.use(
  (config) => {
    // ★ Exact match: the URL must equal the public path (ignoring query strings)
    const urlPath = config.url?.split('?')[0];
    const isPublic = PUBLIC_PATHS.some((p) => urlPath === p);

    if (!isPublic) {
      const token = localStorage.getItem('token');
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// ★ FIX: a 401 means the stored token is stale/invalid — clear it instead of
// leaving isAuthenticated stuck "true" forever, which is what caused every
// protected call (wishlist, etc.) to keep firing and failing on every page.
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.dispatchEvent(new Event('auth:unauthorized'));
    }
    return Promise.reject(error);
  }
);

export default api;
